var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeauSenegal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 16,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33353 1H1V15.9999H8.33353V1Z",
    fill: "#00853F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6695 1H8.33594V15.9999H15.6695V1Z",
    fill: "#FDEF42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0015 1H15.668V15.9999H23.0015V1Z",
    fill: "#E31B23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8917 8.80575L14.3241 7.73977H12.5519L12.0021 6.01489L11.4523 7.73977H9.67969L11.1125 8.80575L10.56 10.5401L12.0021 9.46736L13.4442 10.5401L12.8917 8.80575Z",
    fill: "#00853F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeauSenegal);
export default __webpack_public_path__ + "static/media/drapeauSenegal.ada496de6e43b0f6141cc5a2d85f043c.svg";
export { ForwardRef as ReactComponent };